export const protectedEndpoints: ReadonlyArray<string> = [
  '/auth/v1/user/user-exist-status',
  '/auth/v1/user/check-user-exist',
  '/application/v1/create-citizen',
];

export const emailRegex =
  /^[^<>()[\]\\,;:%#^\s"$&!@]+@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\])|(([a-zA-Z0-9]+\.)+[a-zA-Z]{2,}))$/;
export const phoneRegex = /^07[2-9][0-9]{7}$/;
